import usePage from "@/layout/hooks/usePage";
import { PageId, PageType } from "@/types/page";

type LabelKey = 'saleNumber' | 'customer' | 'price' | 'product' | 'estimatedCost'
  | 'materialProgress' | 'innerNumber' | 'mrd' | 'requireCount' | 'eps' | 'reqDeliDate'
  | 'preFinishDate' | 'saleItem' | 'purchaseProgress' | 'quotationProgress' | 'saleQty'

const useRequirementLabel = () => {
  const { pageId, pageType } = usePage();

  const getLabelShow = (labelKey: LabelKey) => {

    const maps: {
      [key in LabelKey]: boolean
    } = {
      innerNumber: pageType ? false : true,
      saleNumber: pageType ? [PageType.PROD, PageType.PURCHASE, PageType.FINANCE].includes(pageType) : true,
      customer: pageType ? [PageType.PROD, PageType.PURCHASE, PageType.MATERIAL_CONTROL, PageType.FINANCE].includes(pageType) : true,
      price: pageType ? [PageType.PROD, PageType.PURCHASE, PageType.MATERIAL_CONTROL, PageType.FINANCE].includes(pageType) : true,
      product: pageType ? false : true,
      estimatedCost: pageType !== PageType.FINANCE,
      materialProgress: pageType ? [PageType.PURCHASE, PageType.FINANCE].includes(pageType) && pageId !== PageId.PUR_ALL_PASSED : true,
      requireCount: pageType === PageType.PURCHASE,
      mrd: pageType === PageType.FINANCE || pageId === PageId.PROD_NOT_PASS,
      eps: pageType ? pageType === PageType.FINANCE : false,
      reqDeliDate: pageType ? pageType === PageType.FINANCE : false,
      preFinishDate: pageType ? pageType === PageType.FINANCE : false,
      saleItem: pageType ? pageType !== PageType.FINANCE : true,
      purchaseProgress: pageId ? pageId !== PageId.PUR_ALL_PASSED : true,
      quotationProgress: pageId ? ![PageId.MC_PASSED, PageId.PUR_NOT_PASS, PageId.PUR_OM].includes(pageId) : true,
      saleQty: pageId ? [PageId.MC_BE_REJECT, PageId.MC_PASSED, PageId.MC_NOT_PASS, PageId.MC_REQ_MANAGE, PageId.MC_REQ_M].includes(pageId) : false
    }

    return maps[labelKey]
  }

  return { getLabelShow };
};

export default useRequirementLabel;
